import { STUDENT_HISTORY_VIEW, CUSTOM_SMS } from './constants/features';

const settings = {
  [STUDENT_HISTORY_VIEW]: process.env.REACT_APP_STUDENT_HISTORY_FEATURE === 'true',
  [CUSTOM_SMS]: process.env.REACT_APP_CUSTOM_SMS_FEATURE === 'true'
};

export { settings };
